import { getColors, type UIColorTokens } from '@/core/constants/uiColors';
import { useThemeScheme } from '@/core/theme/ThemeProvider';

/**
 * Reusable hook that provides theme-aware UI colors
 * Automatically updates when theme changes
 */
export function useUIColors(): UIColorTokens {
    const scheme = useThemeScheme();
    return getColors(scheme);
}
